<svg class="pex-context-menu-item__icon contex-menu-icons">
    <use attr.xlink:href="{{ icon }}" />
</svg>
<span class="pex-context-menu-item__label"> {{ label }} </span>
